import $ from 'jquery';

export default class TemplateAccountLogin {
  constructor(template) {
    this.el = template.el;
    this.$el = $(this.el);

    $('.guest-login a', this.el).on('click.account', this.submitGuestCheckout.bind(this));
  }

  submitGuestCheckout() {
    $('#customer_login_guest', this.el).submit();
  }

  unload() {
    $('.guest-login a', this.el).off('click.account');
  }
}
